import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/util/axios.config'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { createI18n } from 'vue-i18n'
import zh from '@/i18n/locales/zh.js'

const i18n = createI18n({
	legacy:false,
	locale:'zh',
	messages:{ zh }
})

createApp(App).use(i18n).use(ElementPlus).use(store).use(router).mount('#app')